import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Lee las bases',
    desc: 'Descarga el manual y lee las bases científicas en 10 minutos.'
  }, {
    num: '02',
    title: 'Aplica el Ritual AM',
    desc: 'Ejecútalo en 5 minutos mañana mismo antes de tocar tu teléfono.'
  }, {
    num: '03',
    title: 'Ejecuta el Ritual PM',
    desc: 'Dedica 5 minutos antes de cerrar los ojos para garantizar un descanso profundo.'
  }];
  return <section className="py-24 px-6 bg-[#1C1917] text-[#FAF7F2]" data-id="element-62">
      <div className="max-w-5xl mx-auto" data-id="element-63">
        <FadeIn data-id="element-64">
          <h2 className="font-serif text-3xl md:text-4xl mb-16 text-center" data-id="element-65">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-66">
          <div className="hidden md:block absolute top-8 left-12 right-12 h-px bg-[#332E2B]" data-id="element-67" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.15} className="relative z-10" data-id="element-68">
              <div className="flex flex-col items-center text-center" data-id="element-69">
                <div className="w-16 h-16 rounded-full bg-[#C26D5C] text-white flex items-center justify-center font-serif text-2xl mb-6 shadow-[0_0_0_8px_#1C1917]" data-id="element-70">
                  {step.num}
                </div>
                <h4 className="font-serif text-xl mb-3" data-id="element-71">{step.title}</h4>
                <p className="text-[#A39C97] leading-relaxed" data-id="element-72">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}